import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ColorPickerDirective } from 'ngx-color-picker';
import { DialogService } from 'primeng/dynamicdialog';
import { AppRoutingModule } from '../app-routing.module';
import { NewsletterSignupDialogComponent } from '../components/dialogs/newsletter-signup/newsletter-signup-dialog.component';
import { TopicRequestDialogComponent } from '../components/dialogs/topic-request/topic-request-dialog.component';
import { HeaderAdminComponent } from '../components/shared-components/administration/header-admin/header-admin.component';
import { SidebarAdminComponent } from '../components/shared-components/administration/sidebar-admin/sidebar-admin.component';
import { AgbComponent } from '../components/shared-components/agb/agb.component';
import { AlertComponent } from '../components/shared-components/alert/alert.component';
import { AvatarComponent } from '../components/shared-components/avatar/avatar.component';
import { BookingSuccessComponent } from '../components/shared-components/booking/booking-success/booking-success.component';
import { ChoosePaymentMethodComponent } from '../components/shared-components/booking/choose-payment-method/choose-payment-method.component';
import { PaymentDetailsComponent } from '../components/shared-components/booking/payment-details/payment-details.component';
import { BulkUploadMemberAreasDialogComponent } from '../components/shared-components/bulk-upload-member-areas-dialog/bulk-upload-member-areas-dialog.component';
import { CancelBookingDialogComponent } from '../components/shared-components/cancel-booking-dialog/cancel-booking-dialog.component';
import { CancelSeminarDialogComponent } from '../components/shared-components/cancel-seminar-dialog/cancel-seminar-dialog.component';
import { CaptchaComponent } from '../components/shared-components/captcha/captcha.component';
import { CardHeaderNavigationComponent } from '../components/shared-components/card-header-navigation/card-header-navigation.component';
import { CardSliderComponent } from '../components/shared-components/card-slider/card-slider.component';
import { CardComponent } from '../components/shared-components/card/card.component';
import { ColorPickerComponent } from '../components/shared-components/color-picker/color-picker.component';
import { ConfirmDialogComponent } from '../components/shared-components/confirm-dialog/confirm-dialog.component';
import { ContractRevocationDialogComponent } from '../components/shared-components/contract-revocation-dialog/contract-revocation-dialog.component';
import { CouponCodeComponent } from '../components/shared-components/coupon-code/coupon-code.component';
import { CouponFormularComponent } from '../components/shared-components/coupon-formular/coupon-formular.component';
import { CouponComponent } from '../components/shared-components/coupon/coupon.component';
import { CustomSelectComponent } from '../components/shared-components/custom-select/custom-select.component';
import { CustomTableComponent } from '../components/shared-components/custom-table/custom-table.component';
import { EditAssetDialogComponent } from '../components/shared-components/edit-asset-dialog/edit-asset-dialog.component';
import { EditMemberAreaComponent } from '../components/shared-components/edit-member-area/edit-member-area.component';
import { ErrorMessageComponent } from '../components/shared-components/error-message/error-message.component';
import { FileCardComponent } from '../components/shared-components/file-card/file-card.component';
import { FileManagerComponent } from '../components/shared-components/file-manager/file-manager.component';
import { FilterComponent } from '../components/shared-components/filter/filter.component';
import { FooterComponent } from '../components/shared-components/footer/footer.component';
import { GenerateCouponCodesComponent } from '../components/shared-components/generate-coupon-codes/generate-coupon-codes.component';
import { HeroCardPlaceholderComponent } from '../components/shared-components/hero-card-placeholder/hero-card-placeholder.component';
import { ImageSliderComponent } from '../components/shared-components/image-slider/image-slider.component';
import { ImprintComponent } from '../components/shared-components/imprint/imprint.component';
import { InviteMemberAreaComponent } from '../components/shared-components/invite-member-area/invite-member-area.component';
import { LinkCardComponent } from '../components/shared-components/link-card/link-card.component';
import { MemberAreaContactDialogComponent } from '../components/shared-components/member-area-contact-dialog/member-area-contact-dialog.component';
import { NavbarComponent } from '../components/shared-components/navbar/navbar.component';
import { NewsBannerCardComponent } from '../components/shared-components/news-banner-card/news-banner-card.component';
import { NewsBannerSliderComponent } from '../components/shared-components/news-banner-slider/news-banner-slider.component';
import { NewsDialogComponent } from '../components/shared-components/news-dialog/news-dialog.component';
import { NewsletterComponent } from '../components/shared-components/newsletter/newsletter.component';
import { NoteDialogComponent } from '../components/shared-components/note-dialog/note-dialog.component';
import { PasswordErrorComponent } from '../components/shared-components/password-error/password-error.component';
import { PrivacyPolicyComponent } from '../components/shared-components/privacy-policy/privacy-policy.component';
import { RedeemMemberAreaComponent } from '../components/shared-components/redeem-member-area/redeem-member-area.component';
import { RenameFileModalComponent } from '../components/shared-components/rename-file-modal/rename-file-modal.component';
import { SeminarCardElementComponent } from '../components/shared-components/seminar/seminar-card-element/seminar-card-element.component';
import { SeminarDetailsComponent } from '../components/shared-components/seminar/seminar-details/seminar-details.component';
import { SponsorCardComponent } from '../components/shared-components/sponsor-card/sponsor-card.component';
import { TabMenuComponent } from '../components/shared-components/tab-menu/tab-menu.component';
import { TableHeaderNavigationComponent } from '../components/shared-components/table-header-navigation/table-header-navigation.component';
import { TagSelectionDialogComponent } from '../components/shared-components/tag-selection-dialog/tag-selection-dialog.component';
import { TagSelectorComponent } from '../components/shared-components/tag-selector/tag-selector.component';
import { TeilnahmebedingungenComponent } from '../components/shared-components/teilnahmebedingungen/teilnahmebedingungen.component';
import { TitleCardComponent } from '../components/shared-components/title-card/title-card.component';
import { TopicCardComponent } from '../components/shared-components/topic-card/topic-card.component';
import { TopicRequestComponent } from '../components/shared-components/topic-request/topic-request.component';
import { UploadAssetDialogComponent } from '../components/shared-components/upload-asset-dialog/upload-asset-dialog.component';
import { WorkInProgressComponent } from '../components/shared-components/wip/wip.component';
import { SanitizeHtmlPipe } from '../pipes/sanitize-html.pipe';
import { MaterialModule } from './material.module';
import { PrimeNgModule } from './primeng.module';

@NgModule({
  declarations: [
    ImageSliderComponent,
    CardSliderComponent,
    CardComponent,
    CardHeaderNavigationComponent,
    ErrorMessageComponent,
    EditAssetDialogComponent,
    TitleCardComponent,
    NavbarComponent,
    SidebarAdminComponent,
    HeaderAdminComponent,
    FooterComponent,
    SeminarCardElementComponent,
    NewsletterComponent,
    TopicCardComponent,
    CouponComponent,
    TopicRequestDialogComponent,
    NewsletterSignupDialogComponent,
    SeminarDetailsComponent,
    ChoosePaymentMethodComponent,
    PaymentDetailsComponent,
    BookingSuccessComponent,
    TableHeaderNavigationComponent,
    CustomTableComponent,
    CustomSelectComponent,
    TopicRequestComponent,
    ColorPickerComponent,
    WorkInProgressComponent,
    TabMenuComponent,
    ConfirmDialogComponent,
    ContractRevocationDialogComponent,
    NoteDialogComponent,
    WorkInProgressComponent,
    HeroCardPlaceholderComponent,
    ImprintComponent,
    PrivacyPolicyComponent,
    AgbComponent,
    TeilnahmebedingungenComponent,
    AlertComponent,
    CancelSeminarDialogComponent,
    FilterComponent,
    NewsBannerSliderComponent,
    NewsBannerCardComponent,
    NewsDialogComponent,
    SanitizeHtmlPipe,
    AvatarComponent,
    TagSelectorComponent,
    TagSelectionDialogComponent,
    UploadAssetDialogComponent,
    CouponCodeComponent,
    CouponFormularComponent,
    FileManagerComponent,
    FileCardComponent,
    LinkCardComponent,
    CancelBookingDialogComponent,
    CaptchaComponent,
    SponsorCardComponent,
    PasswordErrorComponent,
    GenerateCouponCodesComponent,
    RedeemMemberAreaComponent,
    RenameFileModalComponent,
    InviteMemberAreaComponent,
    EditMemberAreaComponent,
    MemberAreaContactDialogComponent,
    BulkUploadMemberAreasDialogComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AppRoutingModule,
    MatDialogModule,
    PrimeNgModule,
    ColorPickerDirective,
  ],
  exports: [
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AppRoutingModule,
    PrimeNgModule,
    ColorPickerDirective,
    ImageSliderComponent,
    CardSliderComponent,
    CardComponent,
    CardHeaderNavigationComponent,
    ErrorMessageComponent,
    EditAssetDialogComponent,
    TitleCardComponent,
    NavbarComponent,
    SidebarAdminComponent,
    HeaderAdminComponent,
    FooterComponent,
    SeminarCardElementComponent,
    NewsletterComponent,
    TopicCardComponent,
    CouponComponent,
    TopicRequestDialogComponent,
    NewsletterSignupDialogComponent,
    SeminarDetailsComponent,
    ChoosePaymentMethodComponent,
    PaymentDetailsComponent,
    BookingSuccessComponent,
    TableHeaderNavigationComponent,
    CustomTableComponent,
    CustomSelectComponent,
    TopicRequestComponent,
    ColorPickerComponent,
    WorkInProgressComponent,
    TabMenuComponent,
    ConfirmDialogComponent,
    ContractRevocationDialogComponent,
    NoteDialogComponent,
    WorkInProgressComponent,
    HeroCardPlaceholderComponent,
    ImprintComponent,
    PrivacyPolicyComponent,
    AgbComponent,
    TeilnahmebedingungenComponent,
    AlertComponent,
    CancelSeminarDialogComponent,
    FilterComponent,
    NewsBannerSliderComponent,
    NewsBannerCardComponent,
    NewsDialogComponent,
    SanitizeHtmlPipe,
    AvatarComponent,
    TagSelectorComponent,
    TagSelectionDialogComponent,
    UploadAssetDialogComponent,
    CouponCodeComponent,
    CouponFormularComponent,
    FileManagerComponent,
    FileCardComponent,
    LinkCardComponent,
    CancelBookingDialogComponent,
    CaptchaComponent,
    SponsorCardComponent,
    PasswordErrorComponent,
    GenerateCouponCodesComponent,
    RedeemMemberAreaComponent,
    BulkUploadMemberAreasDialogComponent,
    MemberAreaContactDialogComponent,
  ],
  providers: [DialogService],
  bootstrap: [],
})
export class SharedModule {}
